const INDUSTRIES = [
  {
    title: 'Retail',
    desc: 'Modernizamos operaciones logísticas y centros de distribución para tomar decisiones con datos vivos.',
    path: <path d="M4 7l1-3h14l1 3M4 7v13h16V7M9 11h6" />,
  },
  {
    title: 'Banca y Servicios Financieros',
    desc: 'Plataformas analíticas en tiempo real para banca digital, GenAI y experiencia del cliente.',
    path: <path d="M3 9l9-5 9 5M5 9v9h14V9M9 18v-5M12 18v-5M15 18v-5" />,
  },
  {
    title: 'Aerolíneas',
    desc: 'Programas de lealtad, redención y experiencia del pasajero basados en datos.',
    path: <path d="M2 15l8-3 4-9 2 1-3 9 8 3-1 2-7-2-3 5-2-1 1-5z" />,
  },
  {
    title: 'E-commerce',
    desc: 'Refactorización de arquitecturas y observabilidad de datos para escalar sin sobresaltos.',
    path: (
      <>
        <circle cx="9" cy="20" r="1.5" />
        <circle cx="18" cy="20" r="1.5" />
        <path d="M3 4h2l3 12h11l2-8H7" />
      </>
    ),
  },
  {
    title: 'Medios y Entretenimiento',
    desc: 'Democratización de datos GA4 → BigQuery para directivos, tácticos y operativos.',
    path: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M10 9l5 3-5 3z" fill="currentColor" />
      </>
    ),
  },
  {
    title: 'Conglomerados multinegocio',
    desc: 'Unificación de datos entre verticales con gobernanza federada y visión 360°.',
    path: (
      <>
        <rect x="3" y="10" width="6" height="11" />
        <rect x="9" y="6" width="6" height="15" />
        <rect x="15" y="3" width="6" height="18" />
      </>
    ),
  },
];

export default function Industries() {
  return (
    <section id="industrias" className="py-[120px]">
      <div className="container-etribe">
        <div className="max-w-[720px] mb-16">
          <p className="eyebrow"><span>Sectores</span></p>
          <h2 className="text-[clamp(32px,3.6vw,48px)] mb-4">Industrias que transformamos</h2>
          <p className="text-[clamp(17px,1.3vw,20px)] text-etribe-ink-2 leading-[1.55]">
            Conocimiento vertical para acelerar la implementación: hablamos el lenguaje de tu negocio desde la primera reunión.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 border-t border-l border-etribe-line">
          {INDUSTRIES.map((i) => (
            <article
              key={i.title}
              className="relative overflow-hidden p-10 border-r border-b border-etribe-line bg-white hover:bg-etribe-gray-bg transition-colors flex flex-col items-center text-center gap-5 group"
            >
              {/* Yellow side bar accent on hover */}
              <span
                aria-hidden
                className="absolute left-0 top-0 bottom-0 w-[3px] bg-etribe-yellow origin-bottom scale-y-0 group-hover:scale-y-100 group-hover:origin-top transition-transform duration-400"
              />
              <svg className="w-10 h-10 text-etribe-blue group-hover:-translate-y-0.5 group-hover:scale-105 transition-transform duration-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                {i.path}
              </svg>
              <h3 className="text-[22px]">{i.title}</h3>
              <p className="text-etribe-ink-2 text-sm leading-[1.55]">{i.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
